import {
  Component,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';

import type { ChangelogCategory } from '../../../models/changelog/changelog.model';

@Component({
  selector: 'app-changelog-filter',
  standalone: true,
  imports: [],
  templateUrl: './changelog-filter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./changelog-filter.component.scss'],
})
export class ChangelogFilterComponent {
  @Output() filterChange = new EventEmitter<ChangelogCategory[]>();

  selectedCategories: ChangelogCategory[] = [];

  categories: { value: ChangelogCategory; label: string }[] = [
    { value: 'feature', label: 'Ny funktion' },
    { value: 'improvement', label: 'Forbedring' },
    { value: 'bugfix', label: 'Fejlrettelse' },
  ];

  toggleCategory(category: ChangelogCategory) {
    if (this.selectedCategories.includes(category)) {
      this.selectedCategories = this.selectedCategories.filter(
        (c) => c !== category
      );
    } else {
      this.selectedCategories = [...this.selectedCategories, category];
    }
    this.filterChange.emit(this.selectedCategories);
  }

  clearFilters() {
    this.selectedCategories = [];
    this.filterChange.emit(this.selectedCategories);
  }

  hasSelectedCategories(): boolean {
    return this.selectedCategories.length > 0;
  }
}
